import React from 'react';
import { getIconByMimetype, iconSet } from './FileIconConfig';

export default function FileIcon({ iconCode, mimetype, style }) {
  let iconSrc = null;

  if (iconCode) iconSrc = iconSet[iconCode];
  else if (mimetype) iconSrc = getIconByMimetype(mimetype);

  return (
    <img style={{ ...styleDefault, ...style }} src={iconSrc || iconSet.file} />
  );
}

const styleDefault = {
  maxHeight: 24,
  minWidth: 32,
};
